



// this file should be deleted later








// src/pages/Profile.jsx
import { useEffect, useState } from "react";
import DateInput from "../components/DateInput";
import "../Styles/Profile.css";
// import API from "../api";

export default function Profile_() {
  const [me, setMe] = useState(null);
  const [err, setErr] = useState("");

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const res = await API.get("/auth/profile");
  //       setMe(res.data);
  //     } catch (e) {
  //       setErr(e.response?.data?.error || "Failed to load profile");
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    // 🔴 disable API call and just set dummy profile data
    setMe({
      first_name: "",
      last_name: "",
      email: "",
    });
  }, []);

  if (err) return <div style={{ padding: 24 }}>{err}</div>;
  if (!me) return <div style={{ padding: 24 }}>Loading...</div>;


  return (
    <div className="min-h-screen bg-[length:60px_60px] bg-center bg-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), 
        url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e5e7eb' fill-opacity='0.3'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}
    >
      <div className="profile-form-container max-h-screen  overflow-y-auto">
        <div className="form-header">
          <div className="logo">talent</div>
          <div className="text-sm italic text-[hsl(var(--muted-foreground))]">
            employment inc.
          </div>
          <h1 className="text-lg font-semibold mt-4 mb-0">Profile</h1>
        </div>

        <form>
          {/* General Information */}
          <div className="form-section">
            <h2 className="section-title">General Information</h2>

            <div className="form-row">
              <div className="profile-form-group">
                <label className="profile-form-label">First Name*</label>
                <input type="text" className="profile-form-input" placeholder="John" />
              </div>
              <div className="profile-form-group">
                <label className="profile-form-label">Last Name*</label>
                <input type="text" className="profile-form-input" placeholder="Watson" />
              </div>
            </div>

            <div className="form-row">
              <div className="profile-form-group">
                <label className="profile-form-label">Middle Name</label>
                <input type="text" className="profile-form-input" />
              </div>
              <div className="profile-form-group">
                <label className="profile-form-label">Preferred Name</label>
                <input type="text" className="profile-form-input" />
                <small className="text-xs text-[hsl(var(--muted-foreground))]">
                  Only if different from First Name
                </small>
              </div>
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Email*</label>
              <input type="email" className="profile-form-input" placeholder="example@example.com" />
            </div>

            <div className="form-row">
              <div className="profile-form-group">
                <label className="profile-form-label">Gender</label>
                <select className="profile-form-select">
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="profile-form-group">
                <label className="profile-form-label">Date of Birth</label>
                <DateInput className="profile-form-input" />
              </div>
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Profile Picture</label>
              <div className="avatar-container">
                <div className="avatar">
                  DR
                  <div className="avatar-edit">📷</div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="form-section">
            <h2 className="section-title">Contact Information</h2>

            <div className="profile-form-group">
              <label className="profile-form-label">Mobile number on record with Talent*</label>
              <div className="phone-input-container">
                <select className="country-select">
                  <option value="ca">🇨🇦 +1</option>
                  <option value="us">🇺🇸 +1</option>
                  <option value="lk">🇱🇰 +94</option>
                </select>
                <input type="tel" className="profile-form-input flex-1" />
              </div>
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Address*</label>
              <textarea className="profile-form-input resize-y" rows={3}></textarea>
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Emergency Contact Name*</label>
              <input type="text" className="profile-form-input" />
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Emergency Contact Number*</label>
              <div className="phone-input-container">
                <select className="country-select">
                  <option value="ca">🇨🇦 +1</option>
                  <option value="us">🇺🇸 +1</option>
                  <option value="lk">🇱🇰 +94</option>
                </select>
                <input type="tel" className="profile-form-input flex-1" />
              </div>
            </div>
          </div>

          {/* Payroll Information */}
          <div className="form-section">
            <h2 className="section-title">Payroll Information</h2>

            <div className="profile-form-group">
              <label className="profile-form-label">Residency Status*</label>
              <select className="profile-form-select">
                <option value="">Select Status</option>
                <option value="citizen">Canadian Citizen</option>
                <option value="resident">Permanent Resident</option>
                <option value="work_permit">Work Permit</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="profile-form-group">
              <label className="profile-form-label">Social Insurance Number</label>
              <input type="text" className="profile-form-input" placeholder="XXX-XXX-XXX" />
            </div>
          </div>

          {/* Actions */}
          <div className="form-actions">
            <button type="button" className="btn btn-secondary mb-4">BACK</button>
            <button type="submit" className="btn btn-primary mb-4">SAVE</button>
          </div>
        </form>
      </div>
    </div>
  );
};